import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import type { UAPPlacementComponentProps } from '../@types';

export const PlacementAction = ({
  actionText,
  placementActionClassName,
}: UAPPlacementComponentProps) => (actionText ?
  <button className={classnames(placementActionClassName)}>
    {actionText}
  </button> : null
);

PlacementAction.propTypes = {
  actionText: PropTypes.string,
  placementActionClassName: PropTypes.string,
};

PlacementAction.defaultProps = {
  actionText: undefined,
  placementActionClassName: undefined,
};
